import { on } from 'delegated-events'
import { Swiper, Navigation } from 'swiper'

Swiper.use([Navigation])

const fn = {
  init: () => {
    const elements = document.querySelectorAll('.element-calloutslider')

    if (elements.length) {
      elements.forEach((el) => fn.setupSlider(el))
    }
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper-container')

    if (!container) {
      return
    }

    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 2,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        1024: {
          spaceBetween: 0,
          slidesPerView: 3,
        },
      },
      on: {
        init: (swiper) => {
          fn.handleNavigationControls(swiper, el)
        },
        slideChangeTransitionEnd: (swiper) => {
          fn.handleNavigationControls(swiper, el)
        },
      },
    }

    if (numSlides > 1) {
      const swiper = new Swiper(container, opts)

      on('click', '.callout-slider-button-prev', () => {
        swiper.slidePrev()
      })

      on('click', '.callout-slider-button-next', () => {
        swiper.slideNext()
      })
    }
  },

  handleNavigationControls: (swiper, el) => {
    el.querySelector('.callout-slider-button-prev').classList.remove('swiper-button-disabled')
    el.querySelector('.callout-slider-button-next').classList.remove('swiper-button-disabled')

    if (swiper.isBeginning) {
      el.querySelector('.callout-slider-button-prev').classList.add('swiper-button-disabled')
    }

    if (swiper.isEnd) {
      el.querySelector('.callout-slider-button-next').classList.add('swiper-button-disabled')
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
